import createTheme from '@mui/material/styles/createTheme';
import { borderWidth, spacingLookupTable, spacing, borderRadius, calculateBorderRadius } from '../tokens';
import { breakpoints } from './breakpoints';
import { palette } from './palette';
import { shape } from './shape';
import { typography } from './typography';

// Theme aspects that don't require theme related lookups.
// EX: Breakpoints, palettes, shape, spacing

// This exists in its own file to avoid circular dependency warnings
export const baseTheme = createTheme({
    breakpoints,
    palette,
    shape,
    borderRadius: calculateBorderRadius,
    spacing: Object.values(spacingLookupTable),
    typography,
    tokens: {
        borderWidth,
        borderRadius,
        spacing,
    },
});
